import {
  AnalysisType,
  ChartPlotStyle,
  ChartType,
  DateRangeType,
  InsightsChartType,
  ValueRepresentationType,
} from 'common/types/reports/bookmark';
import {_getDefaultInsightsSorting} from 'common/report/insights/util';

import {TimeUnit} from '../date-range-picker/models/types';

export const commonInsightsBookmarkParams = {
  columnWidths: {
    bar: {},
  },
  displayOptions: {
    analysis: AnalysisType.Linear,
    chartType: ChartType.Line as InsightsChartType,
    plotStyle: ChartPlotStyle.Standard,
    primaryYAxisOptions: {},
    value: ValueRepresentationType.Absolute,
  },
  legend: {
    overrides: {},
  },
  sorting: _getDefaultInsightsSorting({numSegmentColumns: 0, canUseViewN: true}),
};

export const dailyIntervalLast30Days = [
  {
    dateRangeType: DateRangeType.RelativeAfter,
    unit: TimeUnit.Day,
    window: {
      unit: TimeUnit.Day,
      value: 30,
    },
  },
];

export const weeklyIntervalLast3Months = [
  {
    dateRangeType: DateRangeType.RelativeAfter,
    unit: TimeUnit.Week,
    window: {
      unit: TimeUnit.Month,
      value: 3,
    },
  },
];

export const monthlyIntervalLast12Months = [
  {
    dateRangeType: DateRangeType.RelativeAfter,
    unit: TimeUnit.Month,
    window: {
      unit: TimeUnit.Month,
      value: 12,
    },
  },
];

export const MAX_USER_FEED_NAME_LENGTH = 20;
